import React, { PureComponent } from 'react';
import _ from 'lodash';
import Licence from './Licence';
import licenses from '../../../utils/licenses';

class AboutView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { intl } = this.props;
    const listOfLicense = licenses.map((license, index) => {
      return (
        <div key={index}>
          <br />
          <br />
          <u>
            <center>{_.get(license, 'name', '')}</center>
          </u>
          <Licence type={_.get(license, 'type', '')} year={_.get(license, 'year', 'Copyright (c)')} />
        </div>
      );
    });
    return (
      <div>
        <div id="loginWrapper" className="license-page">
          <div className="page-containt">
            <img alt="" className="logo" src="img/logo_kyc.png" />
            <div className="consent-style">
              <p style={{ whiteSpace: 'pre-wrap' }}>{intl.formatMessage({ id: 'AboutMessage' })}</p>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          {listOfLicense}
          <br />
          <br />
          <br />
        </div>
      </div>
    );
  }
}

export default AboutView;
